import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {


  title = 'SYT-System';

  public withOutSideBar: boolean = true;
  static usingLanguage: string;

  constructor(private router: Router, public translate: TranslateService,
     private http: HttpClient) {


    // on route change to '/login', set the variable showHead to false
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/login' || event['url'] == '/') {
          // this.showSideBar = false;
          this.withOutSideBar = true;
        } else {
          // console.log("NU")
          // this.showSideBar = true;
          this.withOutSideBar = false;
        }
      }
    });


  }

  ngOnInit() {
    // 记录当前设置的语言
    localStorage.setItem('currentLanguage', 'zh-TW');

    // 语言初始化(若未设置语言, 则取浏览器语言)
    // let currentLanguage = localStorage.getItem('currentLanguage') || this.translate.getBrowserCultureLang();
    let currentLanguage = localStorage.getItem('currentLanguage') || this.translate.getBrowserCultureLang();

    // 当在assets/i18n中找不到对应的语言翻译时，使用'zh-CN'作为默认语言
    this.translate.setDefaultLang('zh-TW');
    this.translate.use(currentLanguage);

    AppComponent.usingLanguage = currentLanguage;


  
  }



}
